<ng-container *ngTemplateOutlet="getHeader() != null ? pPanel : simple">
</ng-container>

<ng-template #formContent>
  <div [formGroup]="getFormGroup()" [class]="getPanelContentStyleClass()">
    <!-- <ng-template #dynamicComponentContainer></ng-template> -->
    <ng-container *ngFor="let item of config?.config">
      @switch (getFormType(item)) { @case ('input') {
      <eo-input
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (statusChange)="onStatusChange()"
      />
      }@case ('textarea') {
      <eo-textarea
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (statusChange)="onStatusChange()"
      />
      } @case ('checkbox') {
      <eo-checkbox
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (statusChange)="onStatusChange()"
      />
      } @case ('radioButton') {
      <eo-radiobutton
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (statusChange)="onStatusChange()"
      />
      } @case ('dropdown') {
      <eo-dropdown
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (statusChange)="onStatusChange()"
      />
      } @case ('countryDropdown') {
      <eo-country-dropdown
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (statusChange)="onStatusChange()"
      />
      } @case ('specialtyDropdown') {
      <eo-specialty-dropdown
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (statusChange)="onStatusChange()"
      />
      } @case ('userDropdown') {
      <eo-user-dropdown
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (statusChange)="onStatusChange()"
      />
      } @case ('datepicker') {
      <eo-date-picker
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (statusChange)="onStatusChange()"
      />
      }@case ('custom') {
      <ng-container
        *ngTemplateOutlet="
          customFormControls[item.name];
          context: {
            formGroup: getFormGroup(),
            config: item,
            styleClass: item.styleClass
          }
        "
      ></ng-container>
      } }
    </ng-container>
  </div>
</ng-template>

<ng-template #pPanel>
  <p-panel [styleClass]="getStyleClass()">
    <ng-template pTemplate="header">
      <div class="w-full flex justify-content-between">
        <div class="flex gap-2 align-items-center">
          <i
            *ngIf="getHeaderIcon()"
            class="text-xl"
            [class]="getHeaderIcon()"
          ></i>
          <div [class]="getHeaderStyleClass()">{{ getHeader() }}</div>
        </div>
        <div class="flex gap-2"></div>
      </div>
    </ng-template>
    <ng-container *ngTemplateOutlet="formContent"> </ng-container>
  </p-panel>
</ng-template>

<ng-template #simple>
  <ng-container *ngTemplateOutlet="formContent"> </ng-container>
</ng-template>
